import { render, staticRenderFns } from "./CourseProgress.vue?vue&type=template&id=55fda126&scoped=true"
import script from "./CourseProgress.vue?vue&type=script&lang=js"
export * from "./CourseProgress.vue?vue&type=script&lang=js"
import style0 from "./CourseProgress.vue?vue&type=style&index=0&id=55fda126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fda126",
  null
  
)

export default component.exports